import type { BrainstormStructuredData } from '@frontend/api-types';
import { Text, YStack } from '@frontend/web-react';

import { TaskChatBrainstormOptions } from './TaskChatBrainstormOptions';
import { TaskChatClarifyingQuestions } from './TaskChatClarifyingQuestions';

type TaskChatBrainstormContentProps = {
  hasClientResponseAfter: boolean;
  onSubmitComment: (text: string) => Promise<void> | void;
  questions: BrainstormStructuredData | undefined;
};

export const TaskChatBrainstormContent = ({
  hasClientResponseAfter,
  onSubmitComment,
  questions,
}: TaskChatBrainstormContentProps) => {
  if (!questions) return null;

  if (questions.type === 'clarifying_questions') {
    if (hasClientResponseAfter) {
      const headerText =
        questions.questions.length === 1
          ? 'Quick question to help me find the best options:'
          : 'Quick questions to help me find the best options:';
      return (
        <YStack className="gap-md py-md">
          <Text className="text-neutral-950" type="p-md">
            {headerText}
          </Text>
          {questions.questions.map((q, idx) => (
            <Text className="text-neutral-700" key={idx} type="p-sm">
              {idx + 1}. {q.question}
            </Text>
          ))}
        </YStack>
      );
    }
    return (
      <TaskChatClarifyingQuestions
        data={questions}
        onSubmit={async (answers) => {
          const answerText = Object.entries(answers)
            .map(([qIdx, selected]) => {
              const question = questions.questions[Number(qIdx)];
              return `${question?.question} ${selected.join(', ')}`;
            })
            .join('\n');
          await onSubmitComment(answerText);
        }}
      />
    );
  }

  if (questions.type === 'brainstorm_options') {
    return <TaskChatBrainstormOptions data={questions} />;
  }

  return null;
};
